/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 12.04.13
 * Time: 15:17
 */

import { Constants_Offer } from "../Constants_Offer";
import { OfferDescriptionDictionary } from "../OfferDescriptionDictionary";
import { IOfferDescriptionVisualParameter } from "./visualizations/IOfferDescriptionVisualParameter";
import { IPrivateOfferModel } from "../offerQuestConditions/IPrivateOfferModel";
import { IOfferDescription } from "./IOfferDescription";

/**
 * Defines a offer visual container
 */
export class OfferDescriptionVisuals implements IOfferDescription {
    private _visuals: Map<any, any>;
    private _model: IPrivateOfferModel;

    constructor(dataModel: IPrivateOfferModel) {
        this._visuals = new Map<any, any>();
        this._model = dataModel;
    }

    public get name(): string {
        return Constants_Offer.VISUAL_COMPONENT_CONTAINER;
    }

    public registerOfferDescription(dictonary: OfferDescriptionDictionary): void {
        dictonary.addEntry(this.name, this);
    }

    public parseFromObjectParam(params: any): void {
        for (let i: number = 0; i < params.length; ++i) {
            this._visuals.set(params[i].name, this._model.createOfferDescriptionVisualObject(params[i].name, params[i].params));
        }
    }

    public toString(): string {
        let text: string = "Visual Descriptions";
        for (let key of Array.from(this._visuals.keys())) {
            let value: IOfferDescriptionVisualParameter = this._visuals.get(key);
            text += "\n   " + key + " --> " + value;
        }
        return text;
    }

    /**
     * Dictionary of all visual elements
     */
    public get visuals(): Map<any, any> {
        return this._visuals;
    }

    public dispose(): void {
        if (this._visuals) {
            for (let object of Array.from(this._visuals.values())) {
                if (typeof (object.dispose) === "function") {
                    ((<IOfferDescriptionVisualParameter>object)).dispose();
                }
            }

            this._visuals = null;
        }

        this._model = null;
    }
}
